import { render, staticRenderFns } from "./CrearPreguntaSalle.vue?vue&type=template&id=3eac7fd0"
import script from "./CrearPreguntaSalle.vue?vue&type=script&lang=js"
export * from "./CrearPreguntaSalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports